module.exports = __webpack_public_path__ + "img/ko_arima4.06af455d.jpg";